import React from 'react';
import { AiFillHeart, AiOutlineHeart } from 'react-icons/ai';
import { numberWithCommas } from '../util/util';
import { BsChatDots } from 'react-icons/bs';
import { Server } from 'src/server/server';
import '../pages/SitePage.css';
import './ActivityButtons.css';

interface ActivityButtonsProps {
  post: any;
  reply?: boolean;
  onUpdate?: Function;
  likes: number;
  liked: boolean;
}

interface ActivityButtonsState {
  message: string;
  alert: string;
  likes: number;
  liked: boolean;
}

class ActivityButtons extends React.Component<ActivityButtonsProps, ActivityButtonsState> {
  protected processing:boolean;

  constructor(props: ActivityButtonsProps) {
    super(props);
    this.state = {
      message: '',
      alert: '',
      likes: props.likes,
      liked: props.liked
    };
    this.processing = false;
  }

  componentDidMount(): void {
  }

  componentDidUpdate(prevProps: Readonly<ActivityButtonsProps>) {
    if(this.props.post.id != prevProps.post.id) {
      this.setState({
        likes: this.props.likes,
        liked: this.props.liked
      })
    }
    else {
      if(this.props.likes != prevProps.likes) {
        this.setState({likes: this.props.likes})
      }
      if(this.props.liked != prevProps.liked) {
        this.setState({liked: this.props.liked})
      }
    }
  }

  isMobile() {
    return window.matchMedia('(max-width: 500px)').matches;
  }

  async onLike(e:any) {
    e.stopPropagation();

    if(this.processing)
      return;

    if(!Server.account.isLoggedIn()) 
      return;

    const postId = this.props.post.id;
    const storageKey = `LikeButtonLastPressed_${postId}`;
    const now = Date.now();
    let liked = !this.state.liked;
    let likes = this.state.likes + (liked ? 1 : -1);

    // Only throttle if the user is liking (not unliking)
    if (liked) {
      const lastPressed = sessionStorage.getItem(storageKey);
      if (lastPressed && now - parseInt(lastPressed) < 60000) {
        this.setState({ alert: 'You can only like once per minute.' });
        return;
      }
    }

    this.processing = true;
    this.setState({likes, liked, alert: ''});

    let response = null;
    if (liked)
      response = await Server.activity.likePost(postId);
    else
      response = await Server.activity.unlikePost(postId);

    if (response.success) {
      this.props.post.liked = liked;
      this.props.post.likes = likes;
      Server.activity.updatePostInCaches(this.props.post);
      if(this.props.onUpdate)
        this.props.onUpdate();
      // Only set sessionStorage if like was successful and is a like (not unlike)
      if (liked) {
        sessionStorage.setItem(storageKey, now.toString());
      }
    }
    else {
      liked = !liked;
      likes = this.state.likes + (liked ? 1 : -1);
      this.setState({likes, liked});
    }

    this.processing = false;
  }

  render() {
    let margin = this.props.reply && !this.isMobile() ? 55 : 0;
    let likeColor = this.state.liked ? 'red' : 'inherit';

    return (
      <div className='activity-buttons' style={{marginLeft: margin + 'px', marginTop: '5px'}}>
        <div className='activity-button' style={{color: likeColor}} onClick={(e)=>this.onLike(e)}>
          <div className='activity-button-icon'>
            {this.state.liked ? <AiFillHeart /> : <AiOutlineHeart />}
          </div>
          <div>
            {numberWithCommas(this.state.likes)}
          </div>
        </div>
        <div className='activity-button'>
          <div className='activity-button-icon'>
            <BsChatDots />
          </div>
          <div>
            {typeof(this.props.post.replies) == 'number' 
              ? numberWithCommas(this.props.post.replies)
              : this.props.post.replies.length
            }
          </div>
        </div>
        {this.state.alert && (
          <div className='activity-alert' style={{color: 'red', fontSize: '0.9em', marginTop: 2}}>{this.state.alert}</div>
        )}
      </div>
    )
  }
}

export default ActivityButtons;